/* eslint-disable */
import React, { useState, Suspense, useMemo, useCallback, useRef, useEffect, useContext } from "react";
import UIContext from "../../../../../contexts/UIContext/UIContext";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../constants/caption/dashboardHeader";
import DateFnsUtils from "@date-io/date-fns";
import "date-fns";

import { Grid, TextField, Paper, Select, MenuItem, Input, FormControl } from "@material-ui/core";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import Checkbox, { CheckboxProps } from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";
import { Tooltip, Chip } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import { Coverage } from "../../..";
import downloadFile from "../../../../../utils/commonFunctions/downloadFile";
import shortenFileName from "../../../../../utils/commonFunctions/shortenFileName";
import {
	BBI_PLAN_NAMES,
	BBI_PLAN_NAMES_FOR_ALL_EMPLOYEE_CLASS,
	ICI_PLAN_NAMES,
	PFB_PLAN_NAMES,
	PL_PLAN_NAMES,
	PLAN_NAMES,
	PLAN_NAMES_ICI,
	PLAN_NAMES_PL
} from "../../../../../constants/planNames";
import { EMPLOYEE_CLASS, EMPLOYEE_CLASS_ALL } from "../../../../../constants/employeeClass";

// import { Notes } from "../../..";

import FormHelperText from "@material-ui/core/FormHelperText";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EventIcon from "@material-ui/icons/Event";
import PublishIcon from "@material-ui/icons/Publish";

import "./createStaticPlan.css";
import "../../../../../globalStyles/paperFormStyles.css";
import { Validation } from "../../../../../@types/validation.types";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import {
	CoverageType,
	EmployerDeduction,
	EmployerPremiumDeduction,
	// Plan,
	PlanStatus,
	PremiumRateCoverage,
	PremiumType
} from "../../../../../@types/plan.types";
import { EmployeeClass } from "../../../../../@types/paycheck.types";
import { api } from "../../../../../utils/api";
import useRouteParam from "../../../../../hooks/useRouteParam";
import { useNavigate } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";
import { GROUP_NUMBER } from "../../../../../constants/groups";
import { GroupContext } from "../../../../../contexts";
import {
	Box,
	Button,
	FormControlLabel,
	FormGroup,
	FormLabel,
	IconButton,
	InputLabel,
	Modal,
	OutlinedInput,
	Typography
} from "@mui/material";
import { MdDelete } from "react-icons/md";
import { _ } from "ag-grid-community";
import { pl } from "date-fns/locale";
import { previousDay, sub } from "date-fns";
import { group } from "console";
import { get } from "http";
import { IoCloseCircleOutline } from "react-icons/io5";
import LinearProgress from "@mui/material/LinearProgress";
import * as XLSX from "xlsx";
import { CoreConfig, CORE_CONFIG_STEPS } from "../../../../../constants/coreConfig";
import DynamicPlanFields, { collectVisibleFields } from "./DynamicPlanFields";
import { buildCorePlanPayload, buildCoreExcelPayload } from "./buildCorePlanPayload";
import { jsonToExcel } from "./veb/SchemaToExcel";
import { parseCSVSheetsToJSON } from "./veb/VEBpremiumCalculation/VEBpremiumCalculation";

// Define types
interface PlanDependency {
	plan_name: string;
	plan_code: string;
	is_taken_together: boolean;
}

interface InternalDependency {
	sub_plan: {
		required: boolean;
		name: string;
		coverage: Record<string, any>;
	};
}

interface DependentEligibility {
	relationship_type: string;
	min_age: number;
	max_age: number;
}

interface CustomContributionOfEmployees {
	pay_frequency: string; // "WEEKLY" | "MONTHLY" | "BIWEEKLY"
	min_limit: number;
}

interface Plan {
	is_slab_based_premium?: boolean;
	group_number: number;
	plan_year?: number;
	plan_name: string;
	plan_code: string;
	status: string;
	start_date: string;
	end_date: string;
	employee_class: any[];
	buy_up_eligibility: boolean;
	auto_approve: boolean;
	beneficiaries_required: boolean;
	is_end_date_required?: boolean;
	has_premium: boolean;
	has_waive_approval: boolean;
	is_always_open: boolean;
	plan_order: number;
	has_employer_contribution: boolean;
	has_employee_custom_contribution: boolean;
	// custom_contribution_of_employees: { min_limit: number };
	custom_contribution_of_employees: CustomContributionOfEmployees[];
	plan_dependencies: PlanDependency[];
	internal_dependencies: InternalDependency[];
	dependent_eligibility: DependentEligibility[];
	coverage: Record<string, any>;
	employer_contribution: any;
	//   employer_contribution: Record<string, any>;
	document: any;
}

const premiumCoverageColumns = [
	"Coverage", //1
	"Active",
	"Premium Type", //1
	"Monthly Premium", //1
	"Monthly Max Premium", //2
	"Monthly Min Premium", //2
	"Weekly  Premium", //1
	"Weekly Max Premium", //2
	"Weekly Min Premium" //2
];
// let employerContributionColumns:any = [];

const GreenCheckbox = withStyles({
	root: {
		color: green[400],
		"&$checked": {
			color: green[600]
		}
	},
	checked: {}
	// eslint-disable-next-line
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const premiumRateCoverage = {
	active: false,
	premium_type: null,
	monthly_premium: null,
	monthly_maximum_premium: null,
	monthly_minimum_premium: null,
	weekly_premium: null,
	weekly_maximum_premium: null,
	weekly_minimum_premium: null
};
const employeeCoverage = {
	active: false,
	premium_type: "fixed",
	weekly_premium: null,
	monthly_premium: null
};

const date = new Date();
const minDateRange = date.setDate(date.getDate());

const CreateCorePlan = (): JSX.Element => {
	const [isButtonSelected, setIsButtonSelected] = useState(true);

	const [planOrderList, setPlanOrderList] = useState<number[]>([]);
	const [showModal, setShowModal] = useState(false);
	const [shiftAndMoveToLastPlanOrder, setShiftAndMoveToLastPlanOrder] = useState<{
		shift: boolean;
		moveToLast: boolean;
	}>({
		shift: false,
		moveToLast: false
	});

	const { currentGroup, groupInformation } = useContext(GroupContext);

	const [currentPlans, setCurrentPlans] = useState<Plan[]>([]);
	const [groupInfo, setGroupInfo] = useState<any>(null);

	const [employerContributionColumns, setEmployerContributionColumns] = useState<any>([]);
	const [employeeCoverageColumns, setEmployeeCoverageColumns] = useState<any>([]);

	// console.log(groupInformation, "object", currentGroup);

	//setting employeestatus
	const [employee_CLASS, setEmployee_CLASS] = useState(EMPLOYEE_CLASS);
	const queryGroupNumber = useRouteParam("gn");
	const { setDashboardHeader } = useContext(UIContext);
	const [coverageTemplate, setCoverageTemplate] = useState<any>(null);
	const [plan, setPlan] = useState<Plan>({
		group_number: 0,
		plan_name: "",
		plan_code: "",
		status: "",
		start_date: "",
		end_date: "",
		plan_year: 2025,
		employee_class: [],
		buy_up_eligibility: false,
		auto_approve: false,
		beneficiaries_required: false,
		is_end_date_required: false,
		has_premium: false,
		has_waive_approval: false,
		is_always_open: false,
		plan_order: 1,
		has_employer_contribution: false,
		has_employee_custom_contribution: false,
		// custom_contribution_of_employees: { min_limit: 0 },
		custom_contribution_of_employees: [],
		plan_dependencies: [],
		is_slab_based_premium: false,
		internal_dependencies: [],
		dependent_eligibility: [],
		coverage: {
			EE: premiumRateCoverage,
			ES: premiumRateCoverage,
			EC: premiumRateCoverage,
			ECH: premiumRateCoverage,
			ED: premiumRateCoverage,
			premium_without_dependent: false
		},
		employer_contribution: {
			EE: employeeCoverage,
			ES: employeeCoverage,
			EC: employeeCoverage,
			ECH: employeeCoverage
		},
		document: null
	});
	const [pasted, setPasted] = useState(false);
	const [validation, setValidation] = useState<Validation>({
		plan: {},
		status: "valid"
	});
	const _validation = useRef<Validation>();
	const navigate = useNavigate();

	// ── "Same as VEB Structure" mode ──────────────────────────────────────────
	// When on, the whole Core form is replaced by the CoreConfig-driven wizard
	// rendered through <DynamicPlanFields />. State is a flat dotted-path map,
	// exactly like CreateVEBPlanV2's `formData`.
	const [sameAsVebStructure, setSameAsVebStructure] = useState(false);
	const [vebFormData, setVebFormData] = useState<Record<string, any>>({});
	const [vebStep, setVebStep] = useState(1);
	const [vebDocument, setVebDocument] = useState<File | null>(null);
	const [vebExcelFile, setVebExcelFile] = useState<File | null>(null);
	const [vebPremiumJson, setVebPremiumJson] = useState<any>(null);
	const [vebExcelGenerated, setVebExcelGenerated] = useState(false);
	const [vebLoading, setVebLoading] = useState(false);

	const handleVebFieldChange = useCallback((path: string, value: any) => {
		setVebFormData((prev) => ({ ...prev, [path]: value }));
	}, []);

	// `standard_plan_dependency` options — Core's own active plans.
	const activePlansNames = useMemo(
		() => currentPlans.map((p: any) => p.plan_name).filter(Boolean),
		[currentPlans]
	);

	// `rider_plan_dependency` options — riders defined on existing Core plans.
	const activeRiderPlansNames = useMemo(
		() => currentPlans.map((p: any) => p?.rider?.name).filter(Boolean),
		[currentPlans]
	);

	// const handlePaste = (event: React.ClipboardEvent<HTMLDivElement>) => {
	// 	const { name } = event.target as HTMLInputElement;
	// 	if (
	// 		name === "monthly_premium" ||
	// 		name === "weekly_premium" ||
	// 		name === "monthly_maximum_premium" ||
	// 		name === "weekly_maximum_premium" ||
	// 		name === "monthly_minimum_premium" ||
	// 		name === "weekly_minimum_premium" ||
	// 		name === "plan_code" ||
	// 		name === "monthly" ||
	// 		name === "weekly"
	// 	) {
	// 		setPasted(true);
	// 		setTimeout(() => null, 2000);
	// 	}
	// };
	const handlePaste = (event: React.ClipboardEvent<HTMLDivElement>) => {
		const { name } = event.target as HTMLInputElement;

		// Matches anything ending with _premium, _minimum_premium, _maximum_premium,
		// or simple "monthly" / "weekly" / "plan_code"
		if (
			/_premium$|_minimum_premium$|_maximum_premium$/.test(name) ||
			["plan_code", "plan_year", "monthly", "weekly"].includes(name)
		) {
			setPasted(true);
			setTimeout(() => null, 2000);
		}
	};

	const invalidCoverageValidation = useCallback(
		(coverage: any): boolean => {
			if (plan === undefined) return false;
			let isInvalidCoverage = false;

			Object.entries(coverage).some(([key, value]: [string, any]) => {
				if (typeof value !== "object" || value === null || !("premiums" in value)) {
					return false;
				}

				// active validation
				if (value.active === null || value.active === undefined) {
					return true;
				}

				// premium_type validation
				if (!value.premium_type) {
					return true;
				}

				// premium value validation
				if (Array.isArray(value.premiums) && value.premiums.some((p: any) => p.value === null)) {
					return true;
				}

				return false;
			});

			return isInvalidCoverage;
		},
		[plan]
	);

	const handleValidation = useCallback(async () => {
		if (plan === undefined) return;
		const {
			group_number,
			plan_name,
			plan_code,
			status,
			is_end_date_required,
			has_employer_contribution,
			internal_dependencies,
			employee_class,
			buy_up_eligibility,
			start_date,
			end_date,
			coverage,
			plan_order,
			employer_contribution,
			document,
			plan_year,
			has_premium
		} = plan;
		_validation.current = {
			...validation,
			plan: {},
			status: "invalid"
		};
		let flag = true;
		let alertMessage = false;
		console.log("plan year", plan_year);

		const mainCoverage =
			has_premium && (!plan.internal_dependencies || plan.internal_dependencies.length == 0)
				? {
						// has_premium: has_premium,
						coverage: getNormalizedCoveragePayload(coverage as unknown as CoverageType)
				  }
				: {};

		const subPlanCoverage =
			plan.internal_dependencies && plan.internal_dependencies.length > 0
				? plan.internal_dependencies.map((dep) => {
						return {
							sub_plan: {
								coverage: getNormalizedCoveragePayload(
									dep.sub_plan.coverage as unknown as CoverageType
								),
								required: dep.sub_plan.required,
								name: dep.sub_plan.name
							}
						};
				  })
				: [];

		console.log("mainCoverage", mainCoverage);
		console.log("subPlanCoverage", subPlanCoverage);
		let isInvalidCoverage = false;
		if (mainCoverage && mainCoverage.coverage && Object.keys(mainCoverage.coverage).length > 0) {
			isInvalidCoverage = Object.entries(mainCoverage.coverage).some(([key, value]: [string, any]) => {
				if (typeof value !== "object" || value === null || !("premiums" in value)) {
					return false;
				}

				// active validation
				if (value.active === null || value.active === undefined) {
					return true;
				}

				// premium_type validation
				if (!value.premium_type) {
					return true;
				}

				// premium value validation
				if (Array.isArray(value.premiums) && value.premiums.some((p: any) => p.value === null)) {
					return true;
				}

				return false;
			});
		}

		if (isInvalidCoverage) {
			_validation.current.plan["coverage"] = "Coverage configuration is incomplete or invalid";
			_validation.current["status"] = "invalid";
		}

		// alertMessage = true;
		// if (alertMessage) {
		// 	flag = false;
		// 	return;
		// }

		// if(mainCoverage && mainCoverage.coverage)

		if (!plan_year || Number(plan_year) <= 0) {
			_validation.current.plan["plan_year"] = "Plan Year must be greater than 0";
			_validation.current["status"] = "invalid";
			flag = false;
			alertMessage = true;
		}
		if (plan_order <= 0) {
			_validation.current.plan["plan_order"] = "Plan Order must be greater than 0";
			_validation.current["status"] = "invalid";
			flag = false;
			alertMessage = true;
		}
		if (!plan_order) {
			_validation.current.plan["plan_order"] = "Plan Order is required";
			_validation.current["status"] = "invalid";
			flag = false;
			alertMessage = true;
		}
		console.log("plan_order", plan_order, planOrderList);
		if (plan_order && planOrderList.includes(plan_order)) {
			// _validation.current.plan["plan_order"] = "Plan Order must be unique";
			if (!(shiftAndMoveToLastPlanOrder.shift || shiftAndMoveToLastPlanOrder.moveToLast)) {
				setShowModal(true);
				_validation.current["status"] = "invalid";
				flag = false;
			}
			// alertMessage = true;
		}
		if (internal_dependencies && internal_dependencies.length > 0) {
			let foundRequired = false;
			let blankName = false;
			internal_dependencies.forEach((sub_plan: any) => {
				const dep = sub_plan.sub_plan;
				if (dep.required) {
					foundRequired = true;
				}
				if (dep.name.length === 0) {
					blankName = true;
				}
				// console.log("object", dep);
			});
			if (!foundRequired) {
				_validation.current.plan["internal_dependencies"] =
					"at least one subplan should be checked as required and subplan name can't be empty";
				_validation.current["status"] = "invalid";
				flag = false;
				alertMessage = true;
			}
			if (blankName) {
				_validation.current.plan["internal_dependencies"] = "Subplan name can't be empty";
				_validation.current["status"] = "invalid";
				flag = false;
				alertMessage = true;
			}
		}
		if (plan_name.length === 0) {
			_validation.current.plan["plan_name"] = "Plan Name is required";
			_validation.current["status"] = "invalid";
			flag = false;
			alertMessage = true;
		}
		if (plan_code.length === 0) {
			_validation.current.plan["plan_code"] = "Plan Code is required";
			_validation.current["status"] = "invalid";
			flag = false;
			alertMessage = true;
		}
		if (status.length === 0) {
			_validation.current.plan["status"] = "Status is required";
			_validation.current["status"] = "invalid";
			flag = false;
			alertMessage = true;
		}
		if (employee_class.length === 0) {
			_validation.current.plan["employee_class"] = "Employee Class is required";
			_validation.current["status"] = "invalid";
			flag = false;
			alertMessage = true;
		}
		if (start_date.length === 0) {
			_validation.current.plan["start_date"] = "Start Date is required";
			_validation.current["status"] = "invalid";
			flag = false;
			alertMessage = true;
		}
		if (end_date && end_date.length === 0 && is_end_date_required) {
			_validation.current.plan["end_date"] = "End Date is required";
			_validation.current["status"] = "invalid";
			flag = false;
			alertMessage = true;
		}
		if (String(end_date).length !== 0 && is_end_date_required) {
			const startDate = new Date(start_date as string).getTime();
			const endDate = new Date(end_date as string).getTime();
			if (startDate > endDate) {
				_validation.current.plan["end_date"] = "End Date cannot be less than start date";
				_validation.current["status"] = "invalid";
				flag = false;
				alertMessage = true;
			}
		}
		// Object.entries(coverage).map(([coverageKey, coverageDetails], index) => {
		// 	console.log("coverageDetails", coverageDetails);
		// 	if (coverageDetails["active"] === true && _validation?.current) {
		// 		if (coverageDetails["premium_type"] && (coverageDetails["premium_type"] as string).length === 0) {
		// 			_validation.current["status"] = "invalid";
		// 			flag = false;
		// 			alertMessage = true;
		// 		} else if (coverageDetails["premium_type"] === "FIXED") {
		// 			if (coverageDetails["monthly_premium"] === null || coverageDetails["weekly_premium"] === 0) {
		// 				_validation.current["status"] = "invalid";
		// 				flag = false;
		// 				alertMessage = true;
		// 			}
		// 		} else if (coverageDetails["premium_type"] === "PERCENTAGE") {
		// 			if (coverageDetails["monthly_premium"] === null || coverageDetails["weekly_premium"] === null) {
		// 				_validation.current["status"] = "invalid";
		// 				flag = false;
		// 				alertMessage = true;
		// 			}
		// 			if (
		// 				!(
		// 					coverageDetails["premium_type"] === "PERCENTAGE" &&
		// 					Number(coverageDetails["monthly_premium"]) > 0 &&
		// 					Number(coverageDetails["monthly_premium"]) <= 100 &&
		// 					Number(coverageDetails["weekly_premium"]) > 0 &&
		// 					Number(coverageDetails["weekly_premium"]) <= 100
		// 				)
		// 			) {
		// 				_validation.current["status"] = "invalid";
		// 				flag = false;
		// 				alert(
		// 					"Monthly Premium and Weekly Premium values should be between 0 to 100, if premium type is percentage."
		// 				);
		// 			}
		// 			if (
		// 				coverageDetails["monthly_maximum_premium"] &&
		// 				coverageDetails["monthly_minimum_premium"] &&
		// 				!(
		// 					Number(coverageDetails["monthly_maximum_premium"]) >=
		// 					Number(coverageDetails["monthly_minimum_premium"])
		// 				)
		// 			) {
		// 				_validation.current["status"] = "invalid";
		// 				flag = false;
		// 				console.log(
		// 					"coverageDetails[monthly_maximum_premium]",
		// 					coverageDetails["monthly_maximum_premium"]
		// 				);
		// 				console.log(
		// 					"coverageDetails[monthly_minimum_premium]",
		// 					coverageDetails["monthly_minimum_premium"]
		// 				);
		// 				alert("Monthly Maximum Premium must be greater than or equal to Monthly Minimum Premium");
		// 			}
		// 			if (
		// 				coverageDetails["weekly_maximum_premium"] &&
		// 				coverageDetails["weekly_minimum_premium"] &&
		// 				!(
		// 					Number(coverageDetails["weekly_maximum_premium"]) >=
		// 					Number(coverageDetails["weekly_minimum_premium"])
		// 				)
		// 			) {
		// 				_validation.current["status"] = "invalid";
		// 				flag = false;
		// 				alert("Weekly Maximum Premium must be greater than or equal to Weekly Minimum Premium");
		// 			}
		// 		}
		// 	}
		// });
		// Object.entries(employer_contribution).map(([coverageKey, coverageDetails], index) => {
		// 	if (coverageDetails["active"] === true && _validation?.current) {
		// 		if (coverageDetails["monthly_premium"] === null || coverageDetails["weekly_premium"] === null) {
		// 			_validation.current["status"] = "invalid";
		// 			flag = false;
		// 			alertMessage = true;
		// 		}
		// 	}
		// });
		setValidation(Object.assign({}, _validation.current));

		if (flag === true && _validation?.current) {
			_validation.current["status"] = "valid";
			return true;
		} else {
			_validation.current["status"] = "invalid";
			if (alertMessage === true) {
				alert("Please, fill all required Plan details!");
			}
		}
	}, [plan, validation, planOrderList, shiftAndMoveToLastPlanOrder]);

	// ----- Handlers -----
	const handleChange = (path: string, value: string | number | boolean) => {
		setPlan((prev) => {
			const updated: any = { ...prev };
			const keys = path.split(".");
			let obj = updated;

			for (let i = 0; i < keys.length - 1; i++) {
				obj = obj[keys[i]];
			}

			obj[keys[keys.length - 1]] = value;
			return updated;
		});
	};

	const addPlanDependency = () => {
		setPlan((prev) => ({
			...prev,
			plan_dependencies: [...prev.plan_dependencies, { plan_name: "", plan_code: "", is_taken_together: false }]
		}));
	};

	const removePlanDependency = (index: number) => {
		setPlan((prev) => ({
			...prev,
			plan_dependencies: prev.plan_dependencies.filter((_, i) => i !== index)
		}));
	};

	const addInternalDependency = () => {
		setPlan((prev) => ({
			...prev,
			internal_dependencies: [
				...prev.internal_dependencies,
				{
					sub_plan: {
						required: false,
						name: "",
						coverage: JSON.parse(JSON.stringify(coverageTemplate.coverage))
					}
				}
			]
		}));
	};

	const removeInternalDependency = (index: number) => {
		setPlan((prev) => ({
			...prev,
			internal_dependencies: prev.internal_dependencies.filter((_, i) => i !== index)
		}));
	};

	const addDependentEligibility = () => {
		const employer_contribution: any = { active: false };
		const employee_contribution: any = { active: false };
		let employerContributionColumns = ["Coverage", "Active", "Premium Type"];
		const employeeContributionColumns = ["Coverage", "Active", "Premium Type"];
		groupInfo.paycheck_config.forEach((config: any) => {
			employerContributionColumns.push(
				config.pay_frequency.charAt(0).toUpperCase() + config.pay_frequency.slice(1).toLowerCase()
			);

			employeeContributionColumns.push(
				config.pay_frequency.charAt(0).toUpperCase() + config.pay_frequency.slice(1).toLowerCase() + " Premium"
			);
			employeeContributionColumns.push(
				config.pay_frequency.charAt(0).toUpperCase() +
					config.pay_frequency.slice(1).toLowerCase() +
					" Max Premium"
			);
			employeeContributionColumns.push(
				config.pay_frequency.charAt(0).toUpperCase() +
					config.pay_frequency.slice(1).toLowerCase() +
					" Min Premium"
			);

			// "Monthly Premium", //1
			// 	"Monthly Max Premium", //2
			// 	"Monthly Min Premium", //2
			// 	"Weekly  Premium", //1
			// 	"Weekly Max Premium", //2
			// 	"Weekly Min Premium"; //2
			employer_contribution[`${config.pay_frequency.toLowerCase()}_premium`] = null;

			employee_contribution["premium_type"] = null;
			employee_contribution[`${config.pay_frequency.toLowerCase()}_premium`] = null;
			employee_contribution[`${config.pay_frequency.toLowerCase()}_minimum_premium`] = null;
			employee_contribution[`${config.pay_frequency.toLowerCase()}_maximum_premium`] = null;
		});

		let coverageTypes: any = [{ EE: employer_contribution }]; //, "ES", "EC", "ECH", "ED"
		let coverageEmployeeTypes: any = [{ EE: employee_contribution }]; //, "ES", "EC", "ECH", "ED"

		plan.dependent_eligibility.forEach((element) => {
			const relationship_type = element.relationship_type;

			if (relationship_type == "Child") {
				coverageTypes.push({ EC: employer_contribution });
				coverageTypes.push({ ECH: employer_contribution });

				coverageEmployeeTypes.push({ EC: employee_contribution });
				coverageEmployeeTypes.push({ ECH: employee_contribution });
			}

			if (relationship_type == "Spouse") {
				coverageTypes.push({ ES: employer_contribution });
				coverageEmployeeTypes.push({ ES: employee_contribution });
			}
			if (relationship_type == "Dependent") {
				coverageTypes.push({ ED: employer_contribution });
				coverageEmployeeTypes.push({ ED: employee_contribution });
			}
		});

		coverageTypes = coverageTypes.reduce((acc: any, curr: any) => {
			const key = Object.keys(curr)[0];
			acc[key] = curr[key];
			return acc;
		}, {});

		coverageEmployeeTypes = coverageEmployeeTypes.reduce((acc: any, curr: any) => {
			const key = Object.keys(curr)[0];
			acc[key] = curr[key];
			return acc;
		}, {});
		// console.log("coverageTypes", coverageTypes);

		setPlan(
			Object.assign(
				plan,
				{},
				{
					employer_contribution: {
						// EE: employer_contribution,
						// ES: employer_contribution,
						// EC: employer_contribution,
						// ECH: employer_contribution,
						// ED: employer_contribution
						...coverageTypes
					},
					coverage: {
						// EE: employee_contribution,
						// ES: employee_contribution,
						// EC: employee_contribution,
						// ECH: employee_contribution,
						// ED: employee_contribution
						...coverageEmployeeTypes
					},
					dependent_eligibility: [
						...plan.dependent_eligibility,
						{ relationship_type: "", min_age: 0, max_age: 0 }
					]
				}
			)
		);
		setCoverageTemplate({
			coverage: {
				// EE: employee_contribution,
				// ES: employee_contribution,
				// EC: employee_contribution,
				// ECH: employee_contribution,
				// ED: employee_contribution
				...coverageEmployeeTypes
			}
		});

		// setPlan((prev) => ({
		// 	...prev,
		// 	dependent_eligibility: [...prev.dependent_eligibility, { relationship_type: "", min_age: 0, max_age: 0 }]
		// }));
	};

	const removeDependentEligibility = (index: number) => {
		const employer_contribution: any = { active: false };
		const employee_contribution: any = { active: false };
		let employerContributionColumns = ["Coverage", "Active", "Premium Type"];
		const employeeContributionColumns = ["Coverage", "Active", "Premium Type"];
		groupInfo.paycheck_config.forEach((config: any) => {
			employerContributionColumns.push(
				config.pay_frequency.charAt(0).toUpperCase() + config.pay_frequency.slice(1).toLowerCase()
			);

			employeeContributionColumns.push(
				config.pay_frequency.charAt(0).toUpperCase() + config.pay_frequency.slice(1).toLowerCase() + " Premium"
			);
			employeeContributionColumns.push(
				config.pay_frequency.charAt(0).toUpperCase() +
					config.pay_frequency.slice(1).toLowerCase() +
					" Max Premium"
			);
			employeeContributionColumns.push(
				config.pay_frequency.charAt(0).toUpperCase() +
					config.pay_frequency.slice(1).toLowerCase() +
					" Min Premium"
			);

			// "Monthly Premium", //1
			// 	"Monthly Max Premium", //2
			// 	"Monthly Min Premium", //2
			// 	"Weekly  Premium", //1
			// 	"Weekly Max Premium", //2
			// 	"Weekly Min Premium"; //2
			employer_contribution[`${config.pay_frequency.toLowerCase()}_premium`] = null;

			employee_contribution["premium_type"] = null;
			employee_contribution[`${config.pay_frequency.toLowerCase()}_premium`] = null;
			employee_contribution[`${config.pay_frequency.toLowerCase()}_minimum_premium`] = null;
			employee_contribution[`${config.pay_frequency.toLowerCase()}_maximum_premium`] = null;
		});

		let coverageTypes: any = [{ EE: employer_contribution }]; //, "ES", "EC", "ECH", "ED"
		let coverageEmployeeTypes: any = [{ EE: employee_contribution }]; //, "ES", "EC", "ECH", "ED"

		plan.dependent_eligibility.forEach((element) => {
			const relationship_type = element.relationship_type;

			if (relationship_type == "Child") {
				coverageTypes.push({ EC: employer_contribution });
				coverageTypes.push({ ECH: employer_contribution });

				coverageEmployeeTypes.push({ EC: employee_contribution });
				coverageEmployeeTypes.push({ ECH: employee_contribution });
			}

			if (relationship_type == "Spouse") {
				coverageTypes.push({ ES: employer_contribution });
				coverageEmployeeTypes.push({ ES: employee_contribution });
			}
			if (relationship_type == "Dependent") {
				coverageTypes.push({ ED: employer_contribution });
				coverageEmployeeTypes.push({ ED: employee_contribution });
			}
		});

		coverageTypes = coverageTypes.reduce((acc: any, curr: any) => {
			const key = Object.keys(curr)[0];
			acc[key] = curr[key];
			return acc;
		}, {});

		coverageEmployeeTypes = coverageEmployeeTypes.reduce((acc: any, curr: any) => {
			const key = Object.keys(curr)[0];
			acc[key] = curr[key];
			return acc;
		}, {});
		// console.log("coverageTypes", coverageTypes);

		setPlan(
			Object.assign(
				plan,
				{},
				{
					employer_contribution: {
						// EE: employer_contribution,
						// ES: employer_contribution,
						// EC: employer_contribution,
						// ECH: employer_contribution,
						// ED: employer_contribution
						...coverageTypes
					},
					coverage: {
						// EE: employee_contribution,
						// ES: employee_contribution,
						// EC: employee_contribution,
						// ECH: employee_contribution,
						// ED: employee_contribution
						...coverageEmployeeTypes
					},
					dependent_eligibility: plan.dependent_eligibility.filter((_, i) => i !== index)
				}
			)
		);
		setCoverageTemplate({
			coverage: {
				// EE: employee_contribution,
				// ES: employee_contribution,
				// EC: employee_contribution,
				// ECH: employee_contribution,
				// ED: employee_contribution
				...coverageEmployeeTypes
			}
		});
		// setPlan((prev) => ({
		// 	...prev,
		// 	dependent_eligibility: prev.dependent_eligibility.filter((_, i) => i !== index)
		// }));
	};

	// const getEmployerPremiumDeductionPayload = useCallback(
	// 	(coverageKey: EmployerPremiumDeduction): EmployerPremiumDeduction => {
	// 		return {
	// 			active: coverageKey.active,
	// 			weekly_premium: coverageKey.weekly_premium ? Number(coverageKey.weekly_premium) : null,
	// 			monthly_premium: coverageKey.monthly_premium ? Number(coverageKey.monthly_premium) : null
	// 		};
	// 	},
	// 	[]
	// );
	const getEmployerPremiumDeductionPayload = useCallback(
		(coverageKey: EmployerPremiumDeduction): EmployerPremiumDeduction => {
			const payload: any = { active: coverageKey.active };

			Object.entries(coverageKey).forEach(([key, value]) => {
				if (key === "active") return;

				// Handle all fields ending with `_premium`
				if (/_premium$/.test(key)) {
					payload[key] = value ? Number(value) : null;
				} else {
					payload[key] = value;
				}
			});

			return payload;
		},
		[]
	);

	// const getCoveragePremiumPayload = useCallback((coverageKey: PremiumRateCoverage): PremiumRateCoverage => {
	// 	return {
	// 		active: coverageKey.active,
	// 		weekly_premium: coverageKey.weekly_premium ? Number(coverageKey.weekly_premium) : null,
	// 		monthly_premium: coverageKey.monthly_premium ? Number(coverageKey.monthly_premium) : null,
	// 		weekly_maximum_premium: coverageKey.weekly_maximum_premium
	// 			? Number(coverageKey.weekly_maximum_premium)
	// 			: null,
	// 		monthly_maximum_premium: coverageKey.monthly_maximum_premium
	// 			? Number(coverageKey.monthly_maximum_premium)
	// 			: null,
	// 		weekly_minimum_premium: coverageKey.weekly_minimum_premium
	// 			? Number(coverageKey.weekly_minimum_premium)
	// 			: null,
	// 		monthly_minimum_premium: coverageKey.monthly_minimum_premium
	// 			? Number(coverageKey.monthly_minimum_premium)
	// 			: null,
	// 		premium_type: coverageKey.premium_type as PremiumType
	// 	};
	// }, []);
	const getCoveragePremiumPayload = useCallback((coverageKey: PremiumRateCoverage): PremiumRateCoverage => {
		console.log("object premium change", coverageKey);
		const payload: any = { active: coverageKey.active };

		Object.entries(coverageKey).forEach(([key, value]) => {
			if (key === "active" || key === "premium_type" || key === "premium_without_dependent") return;

			// If it's a premium-related field, cast to number or null
			if (/_premium$|_minimum_premium$|_maximum_premium$/.test(key)) {
				payload[key] = value ? Number(value) : null;
			} else {
				payload[key] = value;
			}
		});

		payload.premium_type = coverageKey.premium_type as PremiumType;

		return payload;
	}, []);

	// const getCoveragePayload = useCallback(
	// 	(coverage: CoverageType): CoverageType => {
	// 		// console.log("coverage pa", coverage);
	// 		return {
	// 			EE: getCoveragePremiumPayload(coverage.EE),
	// 			ES: getCoveragePremiumPayload(coverage.ES),
	// 			EC: getCoveragePremiumPayload(coverage.EC),
	// 			ECH: getCoveragePremiumPayload(coverage.ECH),
	// 			ED: getCoveragePremiumPayload(coverage.ED)
	// 		};
	// 	},
	// 	[getCoveragePremiumPayload]
	// );

	const getEmployerDeductionPayload = useCallback(
		(employer_contribution: EmployerDeduction): EmployerDeduction => {
			return {
				EE: getEmployerPremiumDeductionPayload(employer_contribution.EE),
				ES: getEmployerPremiumDeductionPayload(employer_contribution.ES),
				EC: getEmployerPremiumDeductionPayload(employer_contribution.EC),
				ECH: getEmployerPremiumDeductionPayload(employer_contribution.ECH)
			};
		},
		[getEmployerPremiumDeductionPayload]
	);

	type FlatPremium = {
		active: boolean;
		premium_type?: string | null;
		[key: string]: any; // e.g. weekly_premium, monthly_minimum_premium, etc.
	};

	type NormalizedPremium = {
		premiums: {
			pay_frequency: string;
			value: number | null;
			minimum: number | null;
			maximum: number | null;
		}[];
		premium_type?: string | null;
		active: boolean;
	};

	const convertToNormalizedPremium = (input: FlatPremium): NormalizedPremium => {
		const premiumsMap: Record<string, { value: number | null; minimum: number | null; maximum: number | null }> =
			{};

		Object.entries(input).forEach(([key, val]) => {
			const match = key.match(/^(.*?)_(premium|min|max)/);
			if (!match) return;

			const [_, frequency, type] = match;
			if (!premiumsMap[frequency]) {
				premiumsMap[frequency] = { value: null, minimum: null, maximum: null };
			}

			if (key.endsWith("_premium") && !key.includes("minimum") && !key.includes("maximum")) {
				premiumsMap[frequency].value = val;
			} else if (key.includes("minimum")) {
				premiumsMap[frequency].minimum = val;
			} else if (key.includes("maximum")) {
				premiumsMap[frequency].maximum = val;
			}
		});

		return {
			premiums: Object.entries(premiumsMap).map(([frequency, data]) => ({
				pay_frequency: frequency,
				...data
			})),
			premium_type: input.premium_type,
			active: input.active
		};
	};

	const getNormalizedCoveragePayload = useCallback(
		(coverage: CoverageType) => {
			const result: Record<string, any> = {};

			Object.entries(coverage).forEach(([key, value]) => {
				if (key === "premium_without_dependent") {
					result[key] = value;
				} else if (value) {
					result[key] = convertToNormalizedPremium(getCoveragePremiumPayload(value as PremiumRateCoverage));
				}
			});

			return result;
		},
		[getCoveragePremiumPayload]
	);

	const getNormalizedEmployerDeductionPayload = useCallback(
		(employer_contribution: EmployerDeduction) => {
			const result: Record<string, any> = {};

			Object.entries(employer_contribution).forEach(([key, value]) => {
				if (value) {
					result[key] = convertToNormalizedPremium(getEmployerPremiumDeductionPayload(value));
				}
			});

			return result;
		},
		[getEmployerPremiumDeductionPayload]
	);

	const handleCreatePlanClick = useCallback(async () => {
		handleValidation();
		if (_validation?.current && _validation?.current["status"] === "invalid") {
			return;
		}

		const {
			plan_name,
			plan_code,
			buy_up_eligibility,
			auto_approve,
			status,
			employee_class,
			start_date,
			end_date,
			has_employer_contribution,
			is_end_date_required,
			coverage,
			employer_contribution,
			beneficiaries_required,

			has_premium,
			has_waive_approval,
			is_always_open,
			plan_order,
			has_employee_custom_contribution,
			custom_contribution_of_employees,
			plan_dependencies: [],
			internal_dependencies: [],
			dependent_eligibility: [],
			document,
			plan_year
		} = plan;
		const planPayload: any = {
			shiftAndMoveToLastPlanOrder: shiftAndMoveToLastPlanOrder,
			group_number: queryGroupNumber as number,
			plan_name: plan_name.trim(),
			plan_code: plan_code.trim(),

			buy_up_eligibility: buy_up_eligibility,
			status: status as PlanStatus,
			employee_class: employee_class as any[],
			...(has_employer_contribution
				? {
						has_employer_contribution: has_employer_contribution,
						employer_contribution: getNormalizedEmployerDeductionPayload(employer_contribution)
				  }
				: {}),
			...(has_premium && (!plan.internal_dependencies || plan.internal_dependencies.length == 0)
				? {
						// has_premium: has_premium,
						coverage: getNormalizedCoveragePayload(coverage as unknown as CoverageType)
				  }
				: {}),

			// ...(has_employee_custom_contribution
			// 	? {
			// 			has_employee_custom_contribution: has_employee_custom_contribution,
			// 			custom_contribution_of_employees: {
			// 				min_limit: Number(custom_contribution_of_employees.min_limit)
			// 			}
			// 	  }
			// 	: {}),
			...(has_employee_custom_contribution &&
				Array.isArray(custom_contribution_of_employees) &&
				custom_contribution_of_employees.length > 0 && {
					has_employee_custom_contribution,
					custom_contribution_of_employees
				}),

			has_premium: has_premium,
			start_date,
			end_date,
			auto_approve,
			beneficiaries_required,

			has_waive_approval,
			is_always_open,
			plan_order,
			// has_employee_custom_contribution,
			// custom_contribution_of_employees,
			plan_dependencies: plan.plan_dependencies,
			internal_dependencies:
				plan.internal_dependencies && plan.internal_dependencies.length > 0
					? plan.internal_dependencies.map((dep) => {
							return {
								sub_plan: {
									coverage: getNormalizedCoveragePayload(
										dep.sub_plan.coverage as unknown as CoverageType
									),
									required: dep.sub_plan.required,
									name: dep.sub_plan.name
								}
							};
					  })
					: [],
			dependent_eligibility: plan.dependent_eligibility,
			// coverage: getCoveragePayload(coverage as unknown as CoverageType),
			// employer_contribution: getEmployerDeductionPayload(employer_contribution),
			document: null,
			plan_year: Number(plan.plan_year)
		};
		console.log("plannn", planPayload);
		const formData: FormData = new FormData();
		formData.append("plan", JSON.stringify(planPayload));
		formData.append("document", document as unknown as File);
		const createdPlan: any = await trackPromise(api.plan.addPlan(formData));
		if (createdPlan) {
			alert("Plan is succesfully created");
			const pathname = `/employer/plan-management?gn=${queryGroupNumber}`;
			navigate(pathname);
		}
		// console.log("plan", createdPlan);
	}, [getEmployerDeductionPayload, handleValidation, navigate, plan, queryGroupNumber]);

	const handlePremiumCoverageChange = (
		event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
		coverageKey: string
	) => {
		const name = event.target.name;
		let value: number | boolean | PremiumType | undefined | string = "";
		if (name === "active" || name == "premium_without_dependent") {
			const { checked } = event.target as HTMLInputElement;
			value = checked;
		} else {
			value = event.target.value;
		}
		let _value: any = value;
		if (
			// (name === "monthly_premium" ||
			// 	name === "weekly_premium" ||
			// 	name === "monthly_maximum_premium" ||
			// 	name === "weekly_maximum_premium" ||
			// 	name === "monthly_minimum_premium" ||
			// 	name === "weekly_minimum_premium")
			/_premium$|_minimum_premium$|_maximum_premium$/.test(name) &&
			typeof value === "string"
		) {
			//082405002325
			if (!pasted) {
				if (!/^[0-9 .]*$/.test(value) || value.split(".").length - 1 > 1) {
					event.target.value = "";
					_value = Number(
						plan?.coverage[coverageKey as keyof CoverageType][name as keyof PremiumRateCoverage]
					);
				}
			} else {
				// console.log("Pasted");
				setPasted(false);
				if (!/^[0-9 .]*$/.test(value) || value.split(".").length - 1 > 1) {
					alert("Premium Value can only contain numbers and a decimal point(.)");
					event.target.value = "";
					_value = Number(
						plan?.coverage[coverageKey as keyof CoverageType][name as keyof PremiumRateCoverage]
					);
				}
			}
		}
		console.log(coverageKey, "test", name, "p", value);
		if (coverageKey == "premium_without_dependent") {
			// const obj1 = Object.assign({}, plan?.coverage[coverageKey as keyof CoverageType], { [name]: _value });
			const newCoverage = Object.assign({}, plan?.coverage, { [coverageKey]: _value });
			console.log("coverage", newCoverage);
			const obj2 = Object.assign({}, plan, { coverage: newCoverage });
			setPlan(Object.assign({}, obj2));
		} else {
			const obj1 = Object.assign({}, plan?.coverage[coverageKey as keyof CoverageType], { [name]: _value });
			const newCoverage = Object.assign({}, plan?.coverage, { [coverageKey]: obj1 });
			console.log("coverage", newCoverage);
			const obj2 = Object.assign({}, plan, { coverage: newCoverage });
			setPlan(Object.assign({}, obj2));
		}
	};
	const handleSubPlanPremiumCoverageChange = (
		event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
		coverageKey: keyof CoverageType,
		index: number
	) => {
		const name = event.target.name;
		let value: number | boolean | PremiumType | undefined | string = "";
		if (name === "active" || name == "premium_without_dependent") {
			const { checked } = event.target as HTMLInputElement;
			value = checked;
		} else {
			value = event.target.value;
		}
		let _value: any = value;
		console.log(plan?.internal_dependencies, "test 4", _value, "key name", name, index);
		if (
			// (name === "monthly_premium" ||
			// 	name === "weekly_premium" ||
			// 	name === "monthly_maximum_premium" ||
			// 	name === "weekly_maximum_premium" ||
			// 	name === "monthly_minimum_premium" ||
			// 	name === "weekly_minimum_premium")
			/_premium$|_minimum_premium$|_maximum_premium$/.test(name) &&
			typeof value === "string"
		) {
			//082405002325
			if (!pasted) {
				if (!/^[0-9 .]*$/.test(value) || value.split(".").length - 1 > 1) {
					event.target.value = "";
					_value = Number(
						plan?.internal_dependencies[index].sub_plan.coverage[coverageKey as keyof CoverageType][
							name as any
						]
					);
				}
			} else {
				// console.log("Pasted");
				setPasted(false);
				if (!/^[0-9 .]*$/.test(value) || value.split(".").length - 1 > 1) {
					alert("Premium Value can only contain numbers and a decimal point(.)");
					event.target.value = "";
					_value = Number(
						plan?.internal_dependencies[index].sub_plan.coverage[coverageKey as keyof CoverageType][
							name as any
						]
					);
				}
			}
		}
		let obj1, newCoverage;
		// console.log(coverageKey, name, value);
		if (name == "premium_without_dependent") {
			obj1 = Object.assign(
				{},
				plan?.internal_dependencies[index].sub_plan.coverage[coverageKey as keyof CoverageType],
				{ [name]: _value }
			);
			newCoverage = Object.assign({}, plan?.internal_dependencies[index].sub_plan.coverage, {
				[coverageKey]: value
			});

			const obj2 = Object.assign({}, plan, {
				internal_dependencies: [
					{
						...plan.internal_dependencies[index],
						sub_plan: { ...plan.internal_dependencies[index].sub_plan, coverage: newCoverage }
					}
				]
			});
			// setPlan(Object.assign({}, obj2));
			// console.log(name, index, coverageKey, _value, "test");
			setPlan((prev) => ({
				...prev,
				internal_dependencies: prev.internal_dependencies.map((dep, i) =>
					i === index
						? {
								...dep,
								sub_plan: {
									...dep.sub_plan,
									coverage: {
										...dep.sub_plan.coverage,
										[coverageKey]: _value
									}
								}
						  }
						: dep
				)
			}));
		} else {
			obj1 = Object.assign(
				{},
				plan?.internal_dependencies[index].sub_plan.coverage[coverageKey as keyof CoverageType],
				{ [name]: _value }
			);
			newCoverage = Object.assign({}, plan?.internal_dependencies[index].sub_plan.coverage, {
				[coverageKey]: obj1
			});
			const obj2 = Object.assign({}, plan, {
				internal_dependencies: [
					{
						...plan.internal_dependencies[index],
						sub_plan: { ...plan.internal_dependencies[index].sub_plan, coverage: newCoverage }
					}
				]
			});
			// setPlan(Object.assign({}, obj2));
			// console.log(name, index, coverageKey, _value, "test");
			setPlan((prev) => ({
				...prev,
				internal_dependencies: prev.internal_dependencies.map((dep, i) =>
					i === index
						? {
								...dep,
								sub_plan: {
									...dep.sub_plan,
									coverage: {
										...dep.sub_plan.coverage,
										[coverageKey]: {
											...dep.sub_plan.coverage[coverageKey],
											[name]: _value
										}
									}
								}
						  }
						: dep
				)
			}));
		}
		// console.log("coverage", newCoverage);
	};

	const handleEmployersContributionChange = (event: React.ChangeEvent<HTMLInputElement>, coverageKey: string) => {
		const name = event.target.name;
		let value: number | string | undefined | boolean = "";
		if (name === "active") {
			value = event.target.checked;
		} else {
			value = event.target.value;
		}
		let _value: any = value;
		if (/_premium$|_minimum_premium$|_maximum_premium$/.test(name) && typeof value === "string") {
			if (!pasted) {
				if (!/^[0-9 .]*$/.test(value) || value.split(".").length - 1 > 1) {
					event.target.value = "";
					_value = Number(
						plan?.employer_contribution[coverageKey as keyof EmployerDeduction][
							name as keyof EmployerPremiumDeduction
						]
					);
				}
			} else {
				// console.log("Pasted");
				setPasted(false);
				if (!/^[0-9 .]*$/.test(value) || value.split(".").length - 1 > 1) {
					alert("Premium Value can only contain numbers and a decimal point(.)");
					event.target.value = "";
					_value = Number(
						plan?.employer_contribution[coverageKey as keyof EmployerDeduction][
							name as keyof EmployerPremiumDeduction
						]
					);
				}
			}
		}
		if (plan) {
			const obj1 = Object.assign({}, plan.employer_contribution[coverageKey as keyof EmployerDeduction], {
				[name]: _value
			});
			console.log("object", _value, name);
			const newCoverage = Object.assign({}, plan.employer_contribution, { [coverageKey]: obj1 });
			const obj2 = Object.assign({}, plan, { employer_contribution: newCoverage });
			setPlan(Object.assign({}, obj2));
		}
	};

	const handleDocumentChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { files } = event.target;
			// console.log(files);
			if (files) {
				setPlan(Object.assign({}, plan, { document: files[0] }));
				event.target.value = "";
			}
		},
		[plan]
	);

	const handleDeleteDocument = useCallback(() => {
		setPlan(Object.assign({}, plan, { document: null }));
	}, [plan]);

	const handlePlanChange = useCallback(
		(
			event: React.ChangeEvent<HTMLInputElement | { name?: string | undefined; value: unknown }>,
			child?: React.ReactNode
		) => {
			//alert("asd");
			const { name, value } = event.target;
			// console.log("planadsasdasd", name, value);
			let _value: any = value;
			if (name === "plan_code" && typeof value === "string") {
				if (!pasted) {
					if (!/^[a-zA-Z0-9 -]*$/.test(value)) {
						event.target.value = "";
						if (plan) _value = plan[name];
					}
				} else {
					setPasted(false);
					if (!/^[a-zA-Z0-9 -]*$/.test(value)) {
						_value = value.replace(/[^a-zA-Z0-9-]+/g, "").toUpperCase();
					}
				}

				setPlan(Object.assign({}, plan, { [name]: _value.toUpperCase() }));
			} else {
				setPlan(Object.assign({}, plan, { [name as string]: value }));
			}
		},
		[pasted, plan]
	);

	const getPlansWithGroupInformation = useCallback(async () => {
		if (queryGroupNumber) {
			const planStatus: PlanStatus = "ACTIVE";
			const query = {
				status: planStatus,
				group_number: queryGroupNumber
			};
			const { groupInfo, plans } = await trackPromise(api.plan.getPlansWithGroupInformation(query));
			// console.log("plans", plans);
			console.log("groupInfo=====>", groupInfo);
			setCurrentPlans(Object.assign([], plans));
			setGroupInfo(groupInfo);
			setPlanOrderList(plans.map((plan: any) => plan.plan_order));
		}
	}, [queryGroupNumber]);

	const handleStartDateChange = useCallback(
		(date: MaterialUiPickersDate) => {
			const fromDate = new Date(date as any);
			const parsedDate = fromDate.getFullYear() + "-" + (fromDate.getMonth() + 1) + "-" + fromDate.getDate();
			//fromDate = fromDate.getTime();
			const key = "start_date";
			setPlan(Object.assign({}, plan, { [key]: parsedDate }));
		},
		[plan]
	);

	const handleEndDateChange = useCallback(
		(date: MaterialUiPickersDate) => {
			const fromDate = new Date(date as any);
			const parsedDate = fromDate.getFullYear() + "-" + (fromDate.getMonth() + 1) + "-" + fromDate.getDate();
			const key = "end_date";
			setPlan(Object.assign({}, plan, { [key]: parsedDate }));
		},
		[plan]
	);

	const handleCheckboxChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			if (plan && plan["has_employee_custom_contribution"] && event.target.name == "has_premium") {
				alert("please uncheck employee custom contribution , to check this option.");
				return;
			}
			if (plan && plan["has_premium"] && event.target.name == "has_employee_custom_contribution") {
				alert("please uncheck premium option , to check this option.");
				return;
			}
			setPlan(Object.assign({}, plan, { [event.target.name]: event.target.checked }));
		},
		[plan]
	);

	const generatePremiumCoverageRows = useCallback(() => {
		if (!groupInfo) return;

		const employer_contribution: any = { active: false };
		const employee_contribution: any = { active: false };
		let employerContributionColumns = ["Coverage", "Active", "Premium Type"];
		const employeeContributionColumns = ["Coverage", "Active", "Premium Type"];
		groupInfo.paycheck_config.forEach((config: any) => {
			employerContributionColumns.push(
				config.pay_frequency.charAt(0).toUpperCase() + config.pay_frequency.slice(1).toLowerCase()
			);

			employeeContributionColumns.push(
				config.pay_frequency.charAt(0).toUpperCase() + config.pay_frequency.slice(1).toLowerCase() + " Premium"
			);

			employeeContributionColumns.push(
				config.pay_frequency.charAt(0).toUpperCase() +
					config.pay_frequency.slice(1).toLowerCase() +
					" Min Premium"
			);
			employeeContributionColumns.push(
				config.pay_frequency.charAt(0).toUpperCase() +
					config.pay_frequency.slice(1).toLowerCase() +
					" Max Premium"
			);

			// "Monthly Premium", //1
			// 	"Monthly Max Premium", //2
			// 	"Monthly Min Premium", //2
			// 	"Weekly  Premium", //1
			// 	"Weekly Max Premium", //2
			// 	"Weekly Min Premium"; //2
			employer_contribution[`${config.pay_frequency.toLowerCase()}_premium`] = null;

			employee_contribution["premium_type"] = null;
			employee_contribution[`${config.pay_frequency.toLowerCase()}_premium`] = null;
			employee_contribution[`${config.pay_frequency.toLowerCase()}_minimum_premium`] = null;
			employee_contribution[`${config.pay_frequency.toLowerCase()}_maximum_premium`] = null;
		});

		setEmployerContributionColumns(employerContributionColumns);
		setEmployeeCoverageColumns(employeeContributionColumns);
		console.log("key name coverage columns ", employeeContributionColumns);

		let coverageTypes: any = [{ EE: employer_contribution }]; //, "ES", "EC", "ECH", "ED"
		let coverageEmployeeTypes: any = [{ EE: employee_contribution }]; //, "ES", "EC", "ECH", "ED"

		plan.dependent_eligibility.forEach((element) => {
			const relationship_type = element.relationship_type;

			if (relationship_type == "Child") {
				coverageTypes.push({ EC: employer_contribution });
				coverageTypes.push({ ECH: employer_contribution });

				coverageEmployeeTypes.push({ EC: employee_contribution });
				coverageEmployeeTypes.push({ ECH: employee_contribution });
			}

			if (relationship_type == "Spouse") {
				coverageTypes.push({ ES: employer_contribution });
				coverageEmployeeTypes.push({ ES: employee_contribution });
			}
			if (relationship_type == "Dependent") {
				coverageTypes.push({ ED: employer_contribution });
				coverageEmployeeTypes.push({ ED: employee_contribution });
			}
		});

		coverageEmployeeTypes.push({ premium_without_dependent: plan.coverage["premium_without_dependent"] || false });

		coverageTypes = coverageTypes.reduce((acc: any, curr: any) => {
			const key = Object.keys(curr)[0];
			acc[key] = curr[key];
			return acc;
		}, {});

		coverageEmployeeTypes = coverageEmployeeTypes.reduce((acc: any, curr: any) => {
			const key = Object.keys(curr)[0];
			acc[key] = curr[key];
			return acc;
		}, {});
		console.log("coverageEmployeeTypes", coverageEmployeeTypes);

		setPlan(
			Object.assign(
				plan,
				{},
				{
					employer_contribution: {
						// EE: employer_contribution,
						// ES: employer_contribution,
						// EC: employer_contribution,
						// ECH: employer_contribution,
						// ED: employer_contribution
						...coverageTypes
					},
					coverage: {
						// EE: employee_contribution,
						// ES: employee_contribution,
						// EC: employee_contribution,
						// ECH: employee_contribution,
						// ED: employee_contribution
						...coverageEmployeeTypes
					},
					internal_dependencies: plan.internal_dependencies?.map((dep) => ({
						...dep,
						sub_plan: {
							...dep.sub_plan,
							coverage: {
								...coverageEmployeeTypes // apply new coverage to each sub_plan
							}
						}
					}))
				}
			)
		);
		setCoverageTemplate({
			coverage: {
				// EE: employee_contribution,
				// ES: employee_contribution,
				// EC: employee_contribution,
				// ECH: employee_contribution,
				// ED: employee_contribution
				...coverageEmployeeTypes
			}
		});
	}, [groupInfo, plan]);

	useEffect(() => {
		if (groupInfo) generatePremiumCoverageRows();
	}, [groupInfo, JSON.stringify(plan.dependent_eligibility)]);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.static_plan_creation);
	}, [setDashboardHeader]);

	// useEffect(() => {
	// 	if (queryGroupNumber && Number(queryGroupNumber) === 300) {
	// 		setPlan(
	// 			Object.assign(
	// 				plan,
	// 				{},
	// 				{
	// 					employer_contribution: {
	// 						EE: employeeCoverage,
	// 						ES: employeeCoverage,
	// 						EC: employeeCoverage,
	// 						ECH: employeeCoverage,
	// 						ED: employeeCoverage
	// 					}
	// 				}
	// 			)
	// 		);
	// 	}
	// }, [queryGroupNumber]);
	const handleCancel = () => {
		setShiftAndMoveToLastPlanOrder({ moveToLast: false, shift: false });
		setShowModal(false);
	};

	const handleShiftPlans = () => {
		setShiftAndMoveToLastPlanOrder({ moveToLast: false, shift: true });
		setShowModal(false);
	};

	const handleMoveToLast = () => {
		setShiftAndMoveToLastPlanOrder({ moveToLast: true, shift: false });
		setShowModal(false);
	};

	// ── "Same as VEB Structure" wizard ────────────────────────────────────────

	const vebStepFields = useCallback((currentStep: number) => CoreConfig.filter((f) => f.step === currentStep), []);

	/**
	 * Required-field validation for the current step, driven by the config itself
	 * (only fields currently visible are checked), plus the cross-field rules Core
	 * already enforces: unique plan order and start/end date ordering.
	 */
	const validateVebStep = useCallback((): boolean => {
		const visible = collectVisibleFields(vebStepFields(vebStep), vebFormData);

		for (const { field, key } of visible) {
			if (!field.required) continue;

			const value = vebFormData[key];
			const isEmpty =
				value === undefined ||
				value === null ||
				(typeof value === "string" && value.trim() === "") ||
				(Array.isArray(value) && value.length === 0);

			if (isEmpty) {
				alert(`Please fill in "${field.label ?? key}".`);
				return false;
			}
		}

		if (vebStep === 1) {
			const order = Number(vebFormData.plan_order);
			if (order && planOrderList.includes(order)) {
				alert(`Plan order ${order} is already assigned to another plan.`);
				return false;
			}

			if (vebFormData.is_end_date_required && vebFormData.start_date && vebFormData.end_date) {
				const start = new Date(vebFormData.start_date).getTime();
				const end = new Date(vebFormData.end_date).getTime();
				if (start > end) {
					alert("End Date cannot be earlier than Start Date.");
					return false;
				}
				if (start === end) {
					alert("Start Date and End Date cannot be the same.");
					return false;
				}
			}
		}

		return true;
	}, [vebStep, vebFormData, vebStepFields, planOrderList]);

	const handleVebBack = useCallback(() => setVebStep((prev) => Math.max(prev - 1, 1)), []);

	const handleVebNext = useCallback(() => {
		if (!validateVebStep()) return;
		setVebStep((prev) => Math.min(prev + 1, CORE_CONFIG_STEPS.length));
	}, [validateVebStep]);

	/**
	 * Step 6 → 7. Generates the premium workbook from the structure entered so far
	 * and moves to the upload step. Nothing is sent to the server here — the plan
	 * is created in one shot on submit, once premiums are parsed.
	 */
	const handleGenerateVebExcel = useCallback(async () => {
		if (!validateVebStep()) return;

		try {
			setVebLoading(true);

			const payload = buildCorePlanPayload(vebFormData, {
				group_number: queryGroupNumber as number,
				step: vebStep
			});
			const excelPayload = buildCoreExcelPayload(payload, vebFormData);

			await jsonToExcel(`${payload.plan_name || "CORE_PLAN"}_PREMIUM.xlsx`, excelPayload);

			setVebExcelGenerated(true);
			setVebStep(CORE_CONFIG_STEPS.length);
		} catch (err: any) {
			console.error("Failed to generate premium excel", err);
			alert(err?.message || "Failed to generate the premium Excel file.");
		} finally {
			setVebLoading(false);
		}
	}, [validateVebStep, vebFormData, queryGroupNumber, vebStep]);

	/** Parse the filled-in premium workbook into `premium_amount`. */
	const handleVebExcelChange = useCallback(async (selected: File | null) => {
		setVebExcelFile(selected);
		setVebPremiumJson(null);

		if (!selected) return;

		try {
			setVebLoading(true);

			const arrayBuffer = await selected.arrayBuffer();
			const workbook = XLSX.read(new Uint8Array(arrayBuffer), { type: "array" });

			let csvText = "";
			workbook.SheetNames.forEach((sheetName, index) => {
				const sheetCsv = XLSX.utils.sheet_to_csv(workbook.Sheets[sheetName]);
				csvText += `\n\n SHEET ${index + 1}: ${sheetName}\n${sheetCsv}`;
			});

			if (!csvText.trim()) throw new Error("No data extracted from the Excel sheets.");

			setVebPremiumJson(parseCSVSheetsToJSON(csvText));
		} catch (err: any) {
			console.error("Premium excel parse failed", err);
			alert(err?.message || "Could not read that Excel file.");
			setVebExcelFile(null);
		} finally {
			setVebLoading(false);
		}
	}, []);

	/**
	 * Final submit for the VEB-structure path.
	 * Posts to `plan/add-core-plan` (addCorePlan), which is the endpoint that
	 * understands the VEB-shaped payload. The classic Core form keeps using
	 * `plan` (addPlan) via handleCreatePlanClick — see that handler.
	 */
	const handleVebSubmit = useCallback(async () => {
		if (!vebPremiumJson) {
			alert("Please upload the filled-in premium Excel file first.");
			return;
		}

		try {
			const payload = {
				...buildCorePlanPayload(vebFormData, {
					group_number: queryGroupNumber as number,
					premiumAmount: vebPremiumJson,
					step: vebStep
				}),
				shiftAndMoveToLastPlanOrder
			};

			const formDataPayload = new FormData();
			formDataPayload.append("plan", JSON.stringify(payload));
			if (vebDocument) {
				formDataPayload.append("document", vebDocument);
			}

			const createdPlan: any = await trackPromise(api.plan.addCorePlan(formDataPayload));
			if (createdPlan) {
				alert("Plan is successfully created");
				navigate(`/employer/plan-management?gn=${queryGroupNumber}`);
			}
		} catch (err: any) {
			console.error(err);
			alert(err?.response?.data?.message || "Failed to create plan");
		}
	}, [
		vebFormData,
		vebPremiumJson,
		vebDocument,
		queryGroupNumber,
		vebStep,
		shiftAndMoveToLastPlanOrder,
		navigate
	]);

	const payFrequencies = useMemo(() => {
		if (!groupInfo?.paycheck_config) return [];

		return groupInfo.paycheck_config.map((pc: any) => pc.pay_frequency);
	}, [groupInfo?.paycheck_config]);

	useEffect(() => {
		// if (BBI_PLAN_NAMES_FOR_ALL_EMPLOYEE_CLASS.includes(plan.plan_name)) {
		// 	setEmployee_CLASS(EMPLOYEE_CLASS_ALL);
		// 	setPlan(Object.assign({}, plan, { employee_class: "" }));
		// } else {
		setEmployee_CLASS(EMPLOYEE_CLASS);
		setPlan(Object.assign({}, plan, { employee_class: "" }));
		// }
	}, [plan.plan_name]);

	useEffect(() => {
		if (queryGroupNumber) {
			getPlansWithGroupInformation();
		}
	}, [getPlansWithGroupInformation, queryGroupNumber]);

	console.log(plan, "plan", groupInfo);

	// ── VEB-structure mode: config-driven wizard replaces the whole Core form ──
	// Layout intentionally mirrors CreateVEBPlanV2 (pf-page / pf-card / pf-steps)
	// so both plan builders look and behave the same.
	if (sameAsVebStructure) {
		const isFinalStep = vebStep === CORE_CONFIG_STEPS.length;
		const isGenerateStep = vebStep === CORE_CONFIG_STEPS.length - 1;

		return (
			<div className="pf-page">
				<div
					style={{
						maxWidth: "1400px",
						width: "96%",
						margin: "0 auto",
						display: "flex",
						flexDirection: "column",
						gap: 12
					}}
				>
					<Box sx={{ position: "sticky", top: 16, zIndex: 1000 }}>
						<div className="pf-card" style={{ borderRadius: "var(--pf-radius-lg)" }}>
							<div
								className="pf-card-header"
								style={{ padding: "10px 20px 8px", borderBottom: "0.5px solid var(--pf-border)" }}
							>
								<div style={{ display: "flex", alignItems: "baseline", gap: 10 }}>
									<p className="pf-card-title" style={{ fontSize: 16, margin: 0 }}>
										Core Plan
									</p>
									<p className="pf-card-subtitle" style={{ margin: 0, fontSize: 12 }}>
										Complete all required fields across each step.
									</p>
								</div>
							</div>

							<div className="pf-steps" style={{ padding: "8px 20px" }}>
								{CORE_CONFIG_STEPS.map((label, idx) => (
									<div
										key={label}
										className={`pf-step ${
											idx === vebStep - 1
												? "pf-step--active"
												: idx < vebStep - 1
												? "pf-step--done"
												: ""
										}`}
										onClick={() => {
											if (!isFinalStep && idx < vebStep - 1) setVebStep(idx + 1);
										}}
										style={{ cursor: idx < vebStep - 1 ? "pointer" : "default" }}
									>
										{idx + 1} · {label}
									</div>
								))}
							</div>

							<LinearProgress
								variant="determinate"
								value={(vebStep / CORE_CONFIG_STEPS.length) * 100}
								sx={{
									height: 2,
									borderRadius: 0,
									bgcolor: "rgba(0,0,0,0.06)",
									"& .MuiLinearProgress-bar": { backgroundColor: "var(--pf-accent)" }
								}}
							/>
						</div>
					</Box>

					<div className="pf-card" style={{ borderRadius: "var(--pf-radius-lg)" }}>
						<div className="pf-body">
							<div className="pf-field pf-mui-field">
								<div className="pf-label-text">Same as VEB Structure</div>
								<FormControlLabel
									control={
										<GreenCheckbox
											name="same_as_veb_structure"
											checked={sameAsVebStructure}
											onChange={(event) => setSameAsVebStructure(event.target.checked)}
										/>
									}
									label="Build this Core plan using the VEB plan structure"
								/>
							</div>

							<div className="pf-field pf-mui-field">
								<div className="pf-label-text required">Group number</div>
								{/* MUI v4 TextField in this file — no `sx`, so style/inputProps instead. */}
								<TextField
									name="group_number"
									value={queryGroupNumber}
									variant="outlined"
									style={{ width: 200 }}
									inputProps={{ readOnly: true, style: { padding: "9px 12px" } }}
								/>
							</div>

							<hr className="pf-divider" />

							<form onSubmit={(e) => e.preventDefault()}>
								<DynamicPlanFields
									fields={vebStepFields(vebStep)}
									formData={vebFormData}
									onChange={handleVebFieldChange}
									validation={validation}
									activePlansNames={activePlansNames}
									activeRiderPlansNames={activeRiderPlansNames}
									payFrequencies={payFrequencies}
									employeeClassOptions={groupInfo?.employee_class ?? []}
									document={vebDocument}
									onDocumentChange={setVebDocument}
									excelFile={vebExcelFile}
									onExcelFileChange={handleVebExcelChange}
								/>
							</form>
						</div>

						<div className="pf-card-footer">
							<span className="pf-footer-note">* Required fields</span>

							<div className="pf-footer-actions">
								<button
									className="pf-btn"
									onClick={handleVebBack}
									disabled={vebStep === 1 || vebLoading}
									style={{
										opacity: vebStep === 1 ? 0.4 : 1,
										cursor: vebStep === 1 ? "not-allowed" : "pointer"
									}}
								>
									← Back
								</button>

								{isFinalStep ? (
									<button
										className="pf-btn pf-btn--primary"
										onClick={handleVebSubmit}
										disabled={vebLoading || !vebPremiumJson}
									>
										{vebLoading ? "Processing…" : "Submit & Complete"}
									</button>
								) : isGenerateStep ? (
									<button
										className="pf-btn pf-btn--primary"
										onClick={handleGenerateVebExcel}
										disabled={vebLoading}
									>
										{vebLoading ? "Generating…" : "Generate Excel"}
									</button>
								) : (
									<button className="pf-btn pf-btn--primary" onClick={handleVebNext}>
										Continue →
									</button>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="create-static-plan">
			<div className="pf-action-button-container" id="pf-action-button-container">
				<Button className="button-green" variant="contained" onClick={handleCreatePlanClick}>
					<span className="button-label-with-icon">Create Core Plan</span>
					<span>
						<AddCircleIcon className="button-icon" />
					</span>
				</Button>
			</div>
			<Modal open={showModal} onClose={handleCancel} aria-labelledby="duplicate-order-modal">
				<Box
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						width: 400,
						bgcolor: "background.paper",
						boxShadow: 24,
						borderRadius: 2,
						p: 3
					}}
				>
					<Box display="flex" justifyContent="space-between" alignItems="center">
						<Typography id="duplicate-order-modal" variant="h6">
							Duplicate Plan Order
						</Typography>
						<IconButton onClick={handleCancel}>
							<IoCloseCircleOutline />
						</IconButton>
					</Box>

					{/* <Typography sx={{ mt: 2 }}>This plan order number is already assigned to another plan.</Typography> */}
					<Typography sx={{ mt: 2 }}>
						{planOrderList.sort().join(", ") +
							", these plan orders are already assigned to all other plans"}
					</Typography>

					<Box display="flex" justifyContent="flex-end" alignItems="center" gap={1} mt={3}>
						<Button
							variant="contained"
							color="primary"
							size="medium"
							onClick={handleShiftPlans}
							sx={{ textTransform: "none", px: 1 }}
						>
							Shift all Plans by one
						</Button>

						<Button
							variant="contained"
							color="secondary"
							size="medium"
							onClick={handleMoveToLast}
							sx={{ textTransform: "none", px: 1 }}
						>
							Move plan of old {plan.plan_order + "th"} plan order to Last
						</Button>

						<Button
							variant="outlined"
							color="inherit"
							size="medium"
							onClick={handleCancel}
							sx={{ textTransform: "none", px: 1, py: 2 }}
						>
							Cancel
						</Button>
					</Box>
				</Box>
			</Modal>
			<Grid container spacing={1} className="grid-container" style={{ border: "none" }}>
				<div className="pf-title">Basic Details</div>
				<Paper className="pf-paper-container static-plan-container" elevation={3} variant="outlined">
					<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
						<Grid container spacing={1} className="pf-label">
							<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
								<div className="pf-label-text">Same as VEB Structure</div>
							</Grid>
							<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
								<FormControlLabel
									control={
										<GreenCheckbox
											name="same_as_veb_structure"
											checked={sameAsVebStructure}
											onChange={(event) => setSameAsVebStructure(event.target.checked)}
										/>
									}
									label="Build this Core plan using the VEB plan structure"
								/>
							</Grid>
						</Grid>

						<div className="form-field-margin"></div>

						<Grid container spacing={1} className="pf-label">
							<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
								<div className="pf-label-text required">Group Number</div>
							</Grid>
							<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
								<TextField
									className="text-field"
									name="group_number"
									value={queryGroupNumber}
									variant="outlined"
									style={{ width: "340px", borderRadius: 50 }}
									onChange={handlePlanChange}
									inputProps={{
										readOnly: true
									}}
								/>
							</Grid>
						</Grid>

						<div className="form-field-margin"></div>
						<Grid container spacing={1} className="pf-label">
							<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
								<div className="pf-label-text required">Plan Name</div>
							</Grid>
							<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
								<TextField
									className="text-field"
									name="plan_name"
									value={plan?.plan_name}
									variant="outlined"
									style={{ width: "340px", borderRadius: 50 }}
									onChange={handlePlanChange}
									//prettier-ignore
									onPaste={handlePaste}
								/>
								<FormHelperText>{validation.plan["plan_name"]}</FormHelperText>
							</Grid>
						</Grid>
						<div className="form-field-margin"></div>
						<Grid container spacing={1} className="pf-label">
							<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
								<div className="pf-label-text required">Plan Code</div>
							</Grid>
							<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
								<TextField
									className="text-field"
									name="plan_code"
									value={plan?.plan_code}
									variant="outlined"
									style={{ width: "340px", borderRadius: 50 }}
									onChange={handlePlanChange}
									//prettier-ignore
									onPaste={handlePaste}
								/>
								<FormHelperText>{validation.plan["plan_code"]}</FormHelperText>
							</Grid>
						</Grid>
						<div className="form-field-margin"></div>
						<Grid container spacing={1} className="pf-label">
							<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
								<div className="pf-label-text required">Plan Status</div>
							</Grid>
							<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
								<FormControl variant="outlined">
									<Select
										className="status"
										name="status"
										//value={plan?.status}
										onChange={handlePlanChange}
										style={{
											pointerEvents: "unset",
											width: 340,
											textAlign: "left",
											overflowY: "visible"
										}}
										MenuProps={{
											style: { zIndex: 35960 }
										}}
										inputProps={{ "aria-label": "Without label" }}
									>
										<MenuItem value="ACTIVE">Active</MenuItem>
										<MenuItem value="INACTIVE">Inactive</MenuItem>
									</Select>
								</FormControl>
								<FormHelperText>{validation.plan["status"]}</FormHelperText>
							</Grid>
						</Grid>

						<Grid container spacing={1} className="pf-label">
							<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
								<div className="pf-label-text required">Plan Year</div>
							</Grid>
							<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
								<TextField
									className="text-field"
									name="plan_year"
									value={plan?.plan_year}
									variant="outlined"
									style={{ width: "340px", borderRadius: 50 }}
									onChange={handlePlanChange}
									onPaste={handlePaste}
									// inputProps={{
									// 	readOnly: true
									// }}
								/>
							</Grid>
						</Grid>

						<div className="form-field-margin"></div>
					</Grid>
					<div className="form-field-margin"></div>
					<Grid container spacing={1} className="pf-label">
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
							<div className="pf-label-text required">Employee Class</div>
						</Grid>
						<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
							{/* <FormControl variant="outlined" style={{ width: 340 }}>
								<Select
									multiple
									className="emplyoee-container"
									name="employee_class"
									value={plan?.employee_class || []}
									onChange={handlePlanChange}
									style={{
										pointerEvents: "unset",
										textAlign: "left",
										overflowY: "visible"
									}}
									MenuProps={{
										style: { zIndex: 35960 }
									}}
									inputProps={{ "aria-label": "Without label" }}
									renderValue={(selected) => {
										const values = selected as string[];
										return (
											<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
												{values.map((value) => (
													<Chip
														key={value}
														label={value}
														onMouseDown={(event) => event.stopPropagation()} // ✅ prevent dropdown open
														onDelete={(event) => {
															event.stopPropagation(); // ✅ prevent dropdown open
															const newValue = (plan?.employee_class || []).filter(
																(v: string) => v !== value
															);
															handlePlanChange({
																target: { name: "employee_class", value: newValue }
															} as any);
														}}
													/>
												))}
											</Box>
										);
									}}
								>
									{[...(groupInfo?.employee_class ?? [])].map((option: any) => (
										<MenuItem key={option} value={option}>
											{option}
										</MenuItem>
									))}
								</Select>
							</FormControl> */}
							<FormControl component="fieldset" style={{ width: 340 }}>
								{/* <FormLabel component="legend" sx={{ mb: 1 }}>
									Employee Class
								</FormLabel> */}

								<FormGroup>
									{(groupInfo?.employee_class ?? []).map((option: string) => (
										<FormControlLabel
											key={option}
											control={
												<GreenCheckbox
													checked={(plan?.employee_class || []).includes(option)}
													onChange={(event) => {
														const checked = event.target.checked;
														const currentValues = plan?.employee_class || [];

														const newValue = checked
															? [...currentValues, option]
															: currentValues.filter((v: string) => v !== option);

														handlePlanChange({
															target: { name: "employee_class", value: newValue }
														} as any);
													}}
												/>
											}
											label={option}
										/>
									))}
								</FormGroup>
							</FormControl>
							<FormHelperText>{validation.plan["employee_class"]}</FormHelperText>
						</Grid>
					</Grid>
					<div className="form-field-margin"></div>
					<Grid container spacing={1} className="pf-label">
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
							<div className="pf-label-text required">Start Date</div>
						</Grid>
						<Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
							<div className="date-picker">
								<MuiPickersUtilsProvider utils={DateFnsUtils}>
									<KeyboardDatePicker
										className="from-date-input"
										inputVariant="outlined"
										label="Start Date"
										placeholder="Start Date"
										id="from-date-input"
										name="start_date"
										error={false}
										helperText={null}
										format="MM/dd/yyyy"
										value={plan?.start_date}
										onChange={handleStartDateChange}
										InputProps={{
											readOnly: true
										}}
										InputLabelProps={{
											shrink: true
										}}
										minDate={minDateRange}
										//style={{ width: "340px", borderRadius: 50 }}
										keyboardIcon={<EventIcon style={{ color: "#7cb342" }} />}
										KeyboardButtonProps={{
											"aria-label": "change date"
										}}
										disabled={!isButtonSelected}
										style={{
											cursor: !isButtonSelected ? "not-allowed" : "pointer",
											pointerEvents: "unset",
											width: "340px",
											borderRadius: 50
										}}
									/>
								</MuiPickersUtilsProvider>
								<FormHelperText>{validation.plan["start_date"]}</FormHelperText>
							</div>
						</Grid>
					</Grid>
					<div className="form-field-margin"></div>
					<Grid container spacing={1} className="pf-label">
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
							<div className="pf-label-text">Plan Appearance Order</div>
						</Grid>
						<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
							<FormControl variant="outlined">
								{/* <GreenCheckbox
									checked={plan?.appearance_order}
									onChange={handleCheckboxChange}
									name="appearance_order"
								/> */}
								{/* <InputLabel htmlFor="component-outlined">Appearance Order</InputLabel> */}
								<OutlinedInput
									id="component-outlined"
									type="number" // This sets the input type to number
									value={plan?.plan_order}
									onChange={(e) => {
										const value = e.target.value.replace("-", ""); // Remove leading zeros
										if (value === "" || /^[0-9\b]+$/.test(value)) {
											setPlan(
												Object.assign({}, plan, {
													plan_order: value === "" ? "" : Number(value)
												})
											);
										}
									}}
									// style={{ width: "100px", marginLeft: "10px", borderRadius: 50 }}
									// label="Appearance Order"
								/>
							</FormControl>
							<FormHelperText>{validation.plan["plan_order"]}</FormHelperText>
						</Grid>
					</Grid>
					<div className="form-field-margin"></div>
					<Grid container spacing={1} className="pf-label">
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
							<div className="pf-label-text">Does this plan need end date?</div>
						</Grid>
						<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
							<FormControl variant="outlined">
								<GreenCheckbox
									checked={plan?.is_end_date_required}
									onChange={handleCheckboxChange}
									name="is_end_date_required"
								/>
							</FormControl>
						</Grid>
					</Grid>
					{plan?.is_end_date_required ? (
						<>
							<div className="form-field-margin"></div>
							<Grid container spacing={1} className="pf-label">
								<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
									<div className="pf-label-text required">End Date</div>
								</Grid>
								<Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
									<div className="date-picker">
										<MuiPickersUtilsProvider utils={DateFnsUtils}>
											<KeyboardDatePicker
												className="from-date-input"
												inputVariant="outlined"
												label="End Date"
												placeholder="End Date"
												id="from-date-input"
												name="end_date"
												error={false}
												helperText={null}
												format="MM/dd/yyyy"
												value={plan?.end_date}
												onChange={handleEndDateChange}
												InputProps={{
													readOnly: true
												}}
												InputLabelProps={{
													shrink: true
												}}
												//style={{ width: "340px", borderRadius: 50 }}
												keyboardIcon={<EventIcon style={{ color: "#7cb342" }} />}
												KeyboardButtonProps={{
													"aria-label": "change date"
												}}
												disabled={!isButtonSelected}
												style={{
													cursor: !isButtonSelected ? "not-allowed" : "pointer",
													pointerEvents: "unset",
													width: "340px",
													borderRadius: 50
												}}
											/>
										</MuiPickersUtilsProvider>
										<FormHelperText>{validation.plan["end_date"]}</FormHelperText>
									</div>
								</Grid>
							</Grid>
						</>
					) : null}
					<div className="form-field-margin"></div>
					<Grid container spacing={1} className="pf-label">
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
							<div className="pf-label-text">Should this plan Auto-approve?</div>
						</Grid>
						<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
							<FormControl variant="outlined">
								<GreenCheckbox
									checked={plan?.auto_approve}
									onChange={handleCheckboxChange}
									name="auto_approve"
								/>
							</FormControl>
						</Grid>
					</Grid>
					<div className="form-field-margin"></div>
					<Grid container spacing={1} className="pf-label">
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
							<div className="pf-label-text">Is this plan Always Open?</div>
						</Grid>
						<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
							<FormControl variant="outlined">
								<GreenCheckbox
									checked={plan?.is_always_open}
									onChange={handleCheckboxChange}
									name="is_always_open"
								/>
							</FormControl>
						</Grid>
					</Grid>
					<div className="form-field-margin"></div>
					<Grid container spacing={1} className="pf-label">
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
							<div className="pf-label-text">Is Buy Up Eligibility allowed for this plan?</div>
						</Grid>
						<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
							<FormControl variant="outlined">
								<GreenCheckbox
									checked={plan?.buy_up_eligibility}
									onChange={handleCheckboxChange}
									name="buy_up_eligibility"
								/>
							</FormControl>
						</Grid>
					</Grid>
					<div className="form-field-margin"></div>
					<Grid container spacing={1} className="pf-label">
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
							<div className="pf-label-text">Does this plan need Beneficiaries?</div>
						</Grid>
						<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
							<FormControl variant="outlined">
								<GreenCheckbox
									checked={plan?.beneficiaries_required}
									onChange={handleCheckboxChange}
									name="beneficiaries_required"
								/>
							</FormControl>
						</Grid>
					</Grid>
					<div className="form-field-margin"></div>
					<Grid container spacing={1} className="pf-label">
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
							<div className="pf-label-text">Does this plan need Waive Approval?</div>
						</Grid>
						<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
							<FormControl variant="outlined">
								<GreenCheckbox
									checked={plan?.has_waive_approval}
									onChange={handleCheckboxChange}
									name="has_waive_approval"
								/>
							</FormControl>
						</Grid>
					</Grid>
					<div className="form-field-margin"></div>
					<Grid container spacing={1} className="pf-label">
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
							<div className="pf-label-text">Does this plan need Premium?</div>
						</Grid>
						<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
							<FormControl variant="outlined">
								<GreenCheckbox
									checked={plan?.has_premium}
									onChange={handleCheckboxChange}
									name="has_premium"
								/>
							</FormControl>
						</Grid>
					</Grid>
					<div className="form-field-margin"></div>
					<Grid container spacing={1} className="pf-label">
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
							<div className="pf-label-text">Does this plan need Employer&apos;s Contribution?</div>
						</Grid>
						<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
							<FormControl variant="outlined">
								<GreenCheckbox
									checked={plan?.has_employer_contribution}
									onChange={handleCheckboxChange}
									name="has_employer_contribution"
								/>
							</FormControl>
						</Grid>
					</Grid>
					<div className="form-field-margin"></div>
					<Grid container spacing={1} className="pf-label">
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
							<div className="pf-label-text">Upload Brochure</div>
						</Grid>
						<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
							{plan?.document === null ? (
								<>
									<input
										className={"document-upload"}
										id={"document-upload"}
										name={"Document"}
										type="file"
										onChange={handleDocumentChange}
										style={{ display: "none" }}
										accept="image/*, .pdf"
									/>
									<label htmlFor={"document-upload"}>
										<Button
											className="button"
											component="span"
											variant="contained"
											style={{
												backgroundColor: "#3A4652",
												color: "#ffff",
												width: 210
											}}
										>
											<span className="button-label-with-icon" style={{ color: "#ffff" }}>
												{"Add Document"}
											</span>
											<span>
												<PublishIcon className="button-icon" style={{ color: "#ffff" }} />
											</span>
										</Button>
									</label>
								</>
							) : plan?.document ? (
								<Tooltip title={"Click to download"} arrow>
									<Chip
										label={
											plan?.document ? shortenFileName(plan?.document["name"]) : "No files added"
										}
										onDelete={() => handleDeleteDocument()}
										onClick={() => downloadFile(plan?.document)}
									/>
								</Tooltip>
							) : null}
						</Grid>
					</Grid>
					{/* <Divider sx={{ my: 2 }} /> */}
					<div className="form-field-margin"></div>
					{/* ---------- PLAN DEPENDENCIES ---------- */}
					{/* Heading row with two columns */}
					<Grid container spacing={1} className="pf-label" alignItems="center">
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
							<div className="pf-label-text">Plan Dependencies</div>
						</Grid>
						<Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
							<Button onClick={addPlanDependency}>+ Add Dependency</Button>
						</Grid>
					</Grid>
					{/* Dependencies list comes below and spans full width */}
					{plan.plan_dependencies.map((dep, index) => (
						<Grid container spacing={2} alignItems="center" key={index} style={{ marginTop: "8px" }}>
							<Grid item xs={12} sm={3}>
								<TextField
									fullWidth
									label="Plan Name"
									value={dep.plan_name}
									onChange={(e) =>
										handleChange(`plan_dependencies.${index}.plan_name`, e.target.value)
									}
								/>
							</Grid>
							<Grid item xs={12} sm={3}>
								<TextField
									fullWidth
									label="Plan Code"
									value={dep.plan_code}
									onChange={(e) =>
										handleChange(`plan_dependencies.${index}.plan_code`, e.target.value)
									}
								/>
							</Grid>
							<Grid item xs={12} sm={3}>
								<FormControlLabel
									control={
										<Checkbox
											checked={dep.is_taken_together}
											onChange={(e) =>
												handleChange(
													`plan_dependencies.${index}.is_taken_together`,
													e.target.checked
												)
											}
										/>
									}
									label="Taken Together"
								/>
							</Grid>
							<Grid item xs={12} sm={3}>
								<MdDelete
									size={22}
									style={{ cursor: "pointer" }}
									onClick={() => removePlanDependency(index)}
								/>
							</Grid>
						</Grid>
					))}
					{/* <Divider sx={{ my: 2 }} /> */}
					<div className="form-field-margin"></div>
					{/* ---------- INTERNAL DEPENDENCIES ---------- */}
					{/* Heading row with two columns */}
					<Grid container spacing={1} className="pf-label" alignItems="center">
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
							<div className="pf-label-text">Internal Dependencies</div>
						</Grid>
						<Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
							<Button onClick={addInternalDependency}>+ Add Internal Dependency</Button>
						</Grid>
					</Grid>
					<FormHelperText>{validation.plan["internal_dependencies"]}</FormHelperText>
					{plan.internal_dependencies.map((dep, index) => (
						<Grid container spacing={2} alignItems="center" key={index}>
							<Grid item xs={12} sm={3}>
								<FormControlLabel
									control={
										<Checkbox
											checked={dep.sub_plan.required}
											onChange={(e) =>
												handleChange(
													`internal_dependencies.${index}.sub_plan.required`,
													e.target.checked
												)
											}
										/>
									}
									label="Required"
								/>
							</Grid>
							<Grid item xs={12} sm={5}>
								<TextField
									fullWidth
									label="Sub Plan Name"
									value={dep.sub_plan.name}
									onChange={(e) =>
										handleChange(`internal_dependencies.${index}.sub_plan.name`, e.target.value)
									}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<MdDelete
									size={22}
									style={{ cursor: "pointer" }}
									onClick={() => removeInternalDependency(index)}
								/>
							</Grid>
						</Grid>
					))}
					{/* <Divider sx={{ my: 2 }} /> */}
					<div className="form-field-margin"></div>
					{/* ---------- DEPENDENT ELIGIBILITY ---------- */}
					{/* Heading row with two columns */}
					<Grid container spacing={1} className="pf-label" alignItems="center">
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
							<div className="pf-label-text">Dependent Eligibility</div>
						</Grid>
						<Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
							<Button onClick={addDependentEligibility}>+ Add Eligibility</Button>
						</Grid>
					</Grid>
					{plan.dependent_eligibility.map((dep, index) => (
						<Grid container spacing={2} alignItems="center" key={index}>
							{/* <Grid item xs={12} sm={3}>
								<TextField
									fullWidth
									label="Relationship Type"
									value={dep.relationship_type}
									onChange={(e) =>
										handleChange(`dependent_eligibility.${index}.relationship_type`, e.target.value)
									}
								/>
							</Grid> */}
							<Grid item xs={12} sm={3}>
								<TextField
									select
									fullWidth
									label="Relationship Type"
									value={dep.relationship_type}
									onChange={(e) =>
										handleChange(`dependent_eligibility.${index}.relationship_type`, e.target.value)
									}
								>
									<MenuItem value="Spouse">Spouse</MenuItem>
									<MenuItem value="Child">Child</MenuItem>
									<MenuItem value="Dependent">Dependent</MenuItem>
									{/* <MenuItem value="Other">Other</MenuItem> */}
								</TextField>
							</Grid>

							<Grid item xs={12} sm={3}>
								<TextField
									type="number"
									fullWidth
									label="Min Age"
									value={dep.min_age}
									onChange={(e) =>
										handleChange(`dependent_eligibility.${index}.min_age`, +e.target.value)
									}
								/>
							</Grid>
							<Grid item xs={12} sm={3}>
								<TextField
									type="number"
									fullWidth
									label="Max Age"
									value={dep.max_age}
									onChange={(e) =>
										handleChange(`dependent_eligibility.${index}.max_age`, +e.target.value)
									}
								/>
							</Grid>
							<Grid item xs={12} sm={3}>
								{
									<MdDelete
										size={22}
										style={{ cursor: "pointer" }}
										onClick={() => removeDependentEligibility(index)}
									/>
								}
							</Grid>
						</Grid>
					))}
					<div className="form-field-margin"></div>
					{/* ---------- CUSTOM CONTRIBUTION ---------- */}
					<Grid container spacing={1} className="pf-label">
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
							<div className="pf-label-text">Does employee can do any custom contribution?</div>
						</Grid>
						<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
							<FormControl variant="outlined">
								<GreenCheckbox
									checked={plan?.has_employee_custom_contribution}
									onChange={handleCheckboxChange}
									name="has_employee_custom_contribution"
								/>
							</FormControl>
						</Grid>
					</Grid>
					{/* Conditional rendering of custom contribution fields */}
					{/* {plan?.has_employee_custom_contribution && (
						<>
							<div className="form-field-margin"></div>
							<Grid container spacing={1} className="pf-label">
								<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
									<div className="pf-label-text required">
										Custom Contribution of Employee (Min Limit)
									</div>
								</Grid>
								<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
									<TextField
										className="text-field"
										type="number"
										name="custom_contribution_of_employees.min_limit"
										value={plan?.custom_contribution_of_employees?.min_limit}
										variant="outlined"
										style={{ width: "340px", borderRadius: 50 }}
										onChange={(e) =>
											handleChange(
												"custom_contribution_of_employees.min_limit",
												Number(e.target.value)
											)
										}
									/>
									<FormHelperText>
										{validation.plan["custom_contribution_of_employees.min_limit"]}
									</FormHelperText>
								</Grid>
							</Grid>
						</>
					)} */}
					{plan?.has_employee_custom_contribution &&
						payFrequencies.map((frequency: string) => {
							const existing = plan.custom_contribution_of_employees.find(
								(item) => item.pay_frequency === frequency
							);

							return (
								<Grid container spacing={1} className="pf-label" key={frequency}>
									<Grid item xs={12} md={3}>
										<div className="pf-label-text required">
											{frequency.charAt(0) + frequency.slice(1).toLowerCase()}
											&nbsp;Custom Contribution (Min Limit)
										</div>
									</Grid>

									<Grid item xs={9}>
										<TextField
											className="text-field"
											type="number"
											variant="outlined"
											style={{ width: "340px", borderRadius: 50 }}
											value={existing?.min_limit ?? ""}
											onChange={(e) => {
												const value = Number(e.target.value);

												setPlan((prev) => {
													const list = [...prev.custom_contribution_of_employees];
													const index = list.findIndex((i) => i.pay_frequency === frequency);

													if (index > -1) {
														list[index] = {
															...list[index],
															min_limit: value
														};
													} else {
														list.push({
															pay_frequency: frequency,
															min_limit: value
														});
													}

													return {
														...prev,
														custom_contribution_of_employees: list
													};
												});
											}}
										/>
										<FormHelperText>
											{
												validation?.plan?.custom_contribution_of_employees?.find(
													(v: any) => v.pay_frequency === frequency
												)?.min_limit
											}
										</FormHelperText>
									</Grid>
								</Grid>
							);
						})}
				</Paper>
			</Grid>

			{plan?.has_premium ? (
				<>
					{!(plan?.internal_dependencies && plan?.internal_dependencies.length > 0) && (
						<>
							{" "}
							<Grid container spacing={1} className="pf-grid-container">
								<div className="pf-title">Premium Details</div>
							</Grid>
							<Suspense fallback={<div />}>
								<Coverage
									coverage={plan?.coverage}
									handleCoverageChange={handlePremiumCoverageChange}
									planName={plan?.plan_name}
									handlePaste={handlePaste}
									// columns={premiumCoverageColumns}
									columns={employeeCoverageColumns}
									coverageType={"premiumCoverage"}
								/>
							</Suspense>
							<FormHelperText>{validation.plan["coverage"]}</FormHelperText>
						</>
					)}

					{plan?.internal_dependencies.length > 0 &&
						plan?.internal_dependencies.map((item: any, index: number) => (
							<>
								<Grid container spacing={1} className="pf-grid-container">
									<div className="pf-title">Premium Details of sub_plan ({item.sub_plan.name})</div>
								</Grid>
								<Suspense fallback={<div />}>
									<Coverage
										coverage={plan?.internal_dependencies[index].sub_plan.coverage}
										handleCoverageChange={(event: any, coverageKey: keyof CoverageType) => {
											handleSubPlanPremiumCoverageChange(event, coverageKey, index);
										}}
										planName={plan?.plan_name}
										handlePaste={handlePaste}
										// columns={premiumCoverageColumns}
										columns={employeeCoverageColumns}
										coverageType={"premiumCoverage"}
									/>
								</Suspense>
							</>
						))}
				</>
			) : (
				<Grid container spacing={1} className="pf-grid-container"></Grid>
			)}
			{plan?.has_employer_contribution ? (
				<>
					<Grid container spacing={1} className="pf-grid-container">
						<div className="pf-title">Employer&apos;s Contribution</div>
					</Grid>
					<Suspense fallback={<div />}>
						<Coverage
							coverage={plan?.employer_contribution}
							handleCoverageChange={handleEmployersContributionChange}
							planName={plan?.plan_name}
							handlePaste={handlePaste}
							columns={employerContributionColumns}
							coverageType={"employers_contribution"}
						/>
					</Suspense>
				</>
			) : null}
			<div className="pf-action-button-container static-plan-button-container" id="pf-action-button-container">
				<Button className="button-green" variant="contained" onClick={handleCreatePlanClick}>
					<span className="button-label-with-icon">Create Plan</span>
					<span>
						<AddCircleIcon className="button-icon" />
					</span>
				</Button>
			</div>
		</div>
	);
};

export default CreateCorePlan;
